import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/BrandGeometry";

export default function About() {
  return (
    <section id="about" className="border-b border-line bg-white">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:px-10 sm:py-32 lg:px-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <Eyebrow>About Amanah</Eyebrow>
                <h2 className="mt-6 font-display text-4xl font-medium leading-tight tracking-tight text-navy sm:text-5xl">
                  The meaning of Amanah
                </h2>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-8">
            <Reveal>
              <p className="text-lg leading-relaxed text-slate-body">
                Amanah was formed by experienced fundraising professionals with a background in
                face-to-face fundraising and public engagement for charitable causes.
              </p>
              <p className="mt-6 text-lg leading-relaxed text-slate-body">
                Their vision is to deliver professional fundraising through skilled, well-supported
                teams that acquire committed long-term donors, while giving charity partners greater
                clarity and visibility throughout their campaigns.
              </p>
            </Reveal>

            <Reveal delay={0.1}>
              <blockquote className="mt-10 border-l-2 border-brand-green pl-6">
                <p className="font-display text-2xl font-medium leading-snug text-navy sm:text-3xl">
                  The name Amanah represents trust, responsibility and faithful stewardship —
                  principles that shape how the company works with charities, fundraisers and
                  members of the public.
                </p>
              </blockquote>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
